const toastConfig = {
  style: { fontSize: "16px", color: "#1B1B1B" },
  position: "top-center",
  autoClose: 2500,
  closeOnClick: false,
  theme: "light",
};

export default toastConfig